export const GET_TABLE_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    tableBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      name
      heading
      source
      table
      audienceCollection{
        items{
          __typename
          sys{
            id
          }
          audianceId
        }
      }
      rightAlignedColumns
    }
  }
`;
